import ImageModel from "@components/layer-model/image-model";
import * as React from 'react';
export default {
  ImageModel,
  React
};